export default "__VITE_ASSET__DqOHegmy__"